import styled from 'styled-components';

export const Container = styled.div`
  .banner-carousel {
    position: relative;
    width: 100%;
    max-width: 600px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .banner-content {
    width: 100%;
    flex: 1 1 auto;
    min-height: 0;
    aspect-ratio: 988 / 338;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .banner-content button {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    overflow: hidden;
    border-radius: 8px;
    background: transparent;
  }

  .banner-content button .img-banner {
    width: 100%;
    height: auto;
  }

  .dots {
    width: 100%;
    padding-top: 8px;
    display: flex;
    gap: 5px;
    justify-content: center;
  }

  @media (min-width: 768px) {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 15px;
    right: 15px;

    .banner-content {
      aspect-ratio: auto;
    }

    .dots {
      position: absolute;
      top: 100%;
      left: 0;
    }
  }

  .dot {
    width: 10px;
    height: 10px;
    background: ${(props) => props.theme.$gray400};
    border-radius: 50%;
    opacity: 0.5;
    cursor: pointer;
  }

  .dot.active {
    opacity: 1;
  }
`;
